import React, { useState, useEffect, useContext } from 'react';
import Grid from '@mui/material/Grid';
import DialogTitle from '@mui/material/DialogTitle';
import OutlinedInput from '@mui/material/OutlinedInput';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Dialog from '@mui/material/Dialog';
import { NotificationManager } from 'react-notifications';
import "./subSkill.css";
import FormControl from '@mui/material/FormControl';
import CircularProgress from '@mui/material/CircularProgress';
import getAllSkillsResponse from '../../apis/skills/getAllSkills';
import getSubSkillsResponse from '../../apis/skills/getSubSkills';
import addSubSkillsResponse from '../../apis/skills/addSubSkills';
import updateSubSkillsResponse from '../../apis/skills/updateSubSkills';
import addSkillSubSkillStructureResponse from '../../apis/skills/addSkillSubSkillStructure';
import { UserTypeContext } from "../../AppRoute";
import DataTable from '../../components/DataTable/DataTable';
import Tooltip from "@mui/material/Tooltip";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from 'react-router-dom';
import UnauthorizedAccess from '../../components/UnauthorizedAccess/UnauthorizedAccess';
const filterOptions = createFilterOptions({
    matchFrom: 'start',
    stringify: (option) => option.name,
});

function SubSkill({ idContextTest }) {
    const { userType, userIdType } = useContext(UserTypeContext);
    const [allActivePrimarySkill, setallActivePrimarySkill] = useState([]);
    const [openAddModal, setopenAddModal] = useState(false);
    const [subSkillName, setsubSkillName] = useState("");
    const [openEditModal, setopenEditModal] = useState(false);
    const [isLinkSubSkillModalOpen, setisLinkSubSkillModalOpen] = useState(false);
    const [subSkillForLink, setsubSkillForLink] = useState({});
    const [isDataLoaded, setisDataLoaded] = useState(false);
    const [editSubSkillModalValue, seteditSubSkillModalValue] = useState({});
    const [SubSkillNameForEdit, setSubSkillNameForEdit] = useState("");
    const [allSubSkill, setallSubSkill] = useState([]);
    const [skillIdForLink, setskillIdForLink] = useState("");
    const [allSubSkillForCard, setallSubSkillForCard] = useState([]);
    const [subSkillId, setsubSkillId] = useState("");
    const [atvBtn, setAtvBtn] = useState(false);
    const history = useNavigate();

    const columns = [
        {
            id: "edit",
            header: "Edit",
            cell: ({ row }) => (
                <Button
                    variant="contained"
                    color="primary"
                    onClick={() => openEdit(row.original)}
                    className='.edit_button_subskill'
                >
                    Edit
                </Button>
            ),
            size: 80,
            enableSorting: false,
            enableColumnFilter: false,
        },
        {
            accessorKey: "name",
            header: "Sub-Skill",
            size: 300,
            enableSorting: true,
            enableColumnFilter: true,
            filterFn: 'includesString',
        },
    ]
    useEffect(() => {
        const fetchAllData = async () => {
            try {
                await getAllSkills();
                await getAllSubSkills()
            } catch (error) {
                setisDataLoaded(true);
            } finally {
                setisDataLoaded(true);
            }
        }
        if (userType === "Admin") {
            fetchAllData();

        } else {
            setisDataLoaded(true);
        }

        fetchAllData();
    }, []);
    // (ends)


    const getAllSkills = async () => {

        try {
            const SkillResponse = await getAllSkillsResponse();
            if (SkillResponse.status === 200) {


                setallActivePrimarySkill(SkillResponse.data.data)

            }
        }
        catch (error) {
            console.log(error);
        }


    }

    const getAllSubSkills = async () => {

        try {
            const getAllSkillsResponse = await getSubSkillsResponse();

            setallSubSkill(getAllSkillsResponse.data.data)
            setallSubSkillForCard(getAllSkillsResponse.data.data)


        } catch (error) {
            setallSubSkillForCard([])
        }

    }
    const openAdd = () => {
        setopenAddModal(true);

    }
    const closeAddModal = () => {
        setopenAddModal(false);
    }
    const subSkillChange = (e) => {
        const regex = /^\s*$/g
        const subSkillText = e.target.value
        if (subSkillText === '' || regex.test(subSkillText)) {
            setsubSkillName('')
        }
        else if (subSkillText) {
            setsubSkillName(subSkillText)
        }
    }
    const saveSubSkill = async () => {
        setAtvBtn(true);
        if (subSkillName === '') {
            setAtvBtn(false);
            return NotificationManager.error('Please add a sub-skill', "Error", 10000);
        }
        try {
            var payload = {
                "name": subSkillName.trim(),
                // "skillId": skillId,
                "createdBy": userIdType,
                "updatedBy": userIdType
            }
            const addSubSkill = await addSubSkillsResponse(payload);
            if (addSubSkill.data.message?.includes('This Subskill name already')) {
                setAtvBtn(false);
                return (
                    NotificationManager.error('The sub-skill already exists in the system. Please use a different sub-skill name', 'Error', 10000)
                )
            }

            getAllSubSkills();
            NotificationManager.success('Sub-skill  added', 'Success', 10000);
            setAtvBtn(false);
            closeAddModal();

        } catch (error) {
            NotificationManager.error('Sub-Skill addition failed', 'Error', 10000);
            setAtvBtn(false);
        }
    }

    // for edit subSkill
    const openEdit = (valueFromEdit) => {
        setopenEditModal(true)
        seteditSubSkillModalValue(valueFromEdit)
        setSubSkillNameForEdit(valueFromEdit.name)
        if (valueFromEdit.subSkillId) {
            setsubSkillId(valueFromEdit.subSkillId)
        }
        else {
            setsubSkillId(valueFromEdit.id)
        }
    }
    const subSkillChangeHandlerForEdit = (e) => {
        setSubSkillNameForEdit(e.target.value)
    }
    // save updated skill
    const updateSkill = async () => {
        setAtvBtn(true);
        var payload = {
            "name": SubSkillNameForEdit,
            "skillId": editSubSkillModalValue.skillId,
            "updatedBy": userIdType
        }
        try {
            await updateSubSkillsResponse(subSkillId, payload);
            await getAllSubSkills()

            setAtvBtn(false);

            NotificationManager.success('Sub-Skill updated', 'Success', 10000);
            setopenEditModal(false)
        } catch (error) {
            NotificationManager.error('Sub-Skill update failed', 'Error', 10000);
            setAtvBtn(false);
        }
    }
    const closeEditModal = () => {
        setopenEditModal(false)
    }

    // close LinkSub Skill Modal
    const closeLinkSubSkillModal = () => {
        setisLinkSubSkillModalOpen(false)
    }

    const subSkillChangeHandlerForLink = (e, value) => {
        if (value) {
            setsubSkillForLink(value)
        }
    }
    const SkillChangeHandlerForLink = (e, value) => {
        if (value) {
            setskillIdForLink(value.id)
        }
    }
    const LinkSubSkill = async () => {
        var payload =
        {
            "code": subSkillForLink.name,
            "name": subSkillForLink.name,
            "skillId": skillIdForLink,
            "subSkillId": subSkillForLink.id,
            "isActive": true,
            "createdBy": userIdType,
            "updatedBy": userIdType
        }

        await addSkillSubSkillStructureResponse(payload);
        NotificationManager.success('The selected skill and subskill are linked', 'Success', 10000);
        setisLinkSubSkillModalOpen(false)
    }



    const btnGreen = {
        color: "#fff",
        backgroundColor: "#1885e6",
        border: "none",
        padding: "8px 32px",
        whiteSpace: "nowrap",
        fontWeight: 500,
        fontSize: "1rem",
        borderRadius: "4px",
        boxShadow: "none",
    };
    const closeButton = {
        position: 'absolute',
        right: 0,
        top: 0,
        color: 'grey',
    };
    const btnSavegreen = {
        color: '#fff',
        backgroundColor: '#2AD156',
        border: '1px solid #2AD156',
    };

    const goToDashboard = () => {
        history("/admin-home");
    };



    return (
        <>
            <div className='main_container_subskill'>
                        {!isDataLoaded ?
                            <div className="row padding_80 text-center">
                                <CircularProgress />
                            </div>
                            :
                            <>
                                {
                                    userType === "Admin" ?
                                        
                                            <Grid container spacing={3} className="main_gridContainer_subskill">
                                                <div className='admin_subskill_subContainer'>
                                                    <div className='admin_subskill_leftsection'>
                                                        <div className="goBackButton" onClick={(e) => goToDashboard(e)}>
                                                            <Tooltip title="Go Back to Dashboard" placement="bottom">
                                                                <ArrowBackIcon sx={{ fontSize: 20 }} />
                                                            </Tooltip>
                                                        </div>
                                                        <div className="communityTitle_subskill">Sub-Skills</div>
                                                    </div>
                                                    <Button variant="outlined" style={btnGreen} onClick={openAdd}>
                                                        Add Sub-Skill
                                                    </Button>
                                                </div>
                                                <Grid size={{ xs: 12, md: 12 }}>
                                                </Grid>
                                                <DataTable
                                                    data={allSubSkillForCard}
                                                    columns={columns}
                                                    isLoading={!isDataLoaded}
                                                />
                                            </Grid>
                                        
                                        : userType === "" ? (
                                            <div className="row padding_80 text-center">
                                                <p className="fs-semi-bold fs-40 f-color">
                                                    Loading...
                                                </p>
                                            </div>
                                        )
                                            : (
                                                <UnauthorizedAccess />
                                            )
                                }
                            </>
                        }
                        </div>
                

            <Dialog
                onClose={closeAddModal}
                aria-labelledby="customized-dialog-title"
                open={openAddModal}
                PaperProps={{
                    style: {
                        width: '600px',
                    },
                }}
            >
                <DialogTitle id="customized-dialog-title"
                    onClose={closeAddModal}
                    className="admindailog_title_modal_subskill"
                >
                    Add Sub-Skill
                    <IconButton
                        aria-label="close"
                        style={closeButton}
                        onClick={closeAddModal}>
                        <CloseIcon />
                    </IconButton>

                </DialogTitle>
                <DialogContent >
                    <Typography gutterBottom>
                        Sub-Skill
                    </Typography>

                    <FormControl fullWidth variant="outlined">
                        <OutlinedInput
                            placeholder="Enter Sub-Skill"
                            className="admin_textbox"
                            onChange={(e) => subSkillChange(e)}
                        />
                    </FormControl>
                </DialogContent>
                <Grid size={{ xs: 12, md: 12 }} className="user_pop_button" >
                    <DialogActions>
                        <Button variant="outlined" className="btn3 cp" color="primary" onClick={closeAddModal}>
                            Cancel
                        </Button>

                        <button variant="outlined" className="btn3 btn_primary cp" disabled={atvBtn} onClick={saveSubSkill}>
                            <div className="btn_loader">
                                Save
                                &nbsp;
                                {atvBtn &&
                                    <div >
                                        <CircularProgress size={13} />
                                    </div>
                                }
                            </div>
                        </button>
                    </DialogActions>
                </Grid>
            </Dialog>




            {/* modal  for edit*/}

            <Dialog
                onClose={closeEditModal}
                aria-labelledby="customized-dialog-title"
                open={openEditModal}
                PaperProps={{
                    style: {
                        width: '600px',
                    },
                }}
            >
                <DialogTitle id="customized-dialog-title"
                    onClose={closeEditModal}
                    className="admindailog_title_modal_subskill"
                >
                    Edit Sub-Skill
                    <IconButton
                        aria-label="close"
                        style={closeButton}
                        onClick={closeEditModal}>
                        <CloseIcon />
                    </IconButton>

                </DialogTitle>
                <DialogContent className="userlist_dailog_content">
                    <Typography gutterBottom>
                        Sub-Skill
                    </Typography>
                    <FormControl fullWidth variant="outlined">
                        <OutlinedInput
                            placeholder="Name"
                            className="admin_textbox"
                            defaultValue={SubSkillNameForEdit}
                            onChange={subSkillChangeHandlerForEdit}
                        />
                    </FormControl>

                </DialogContent>
                <Grid size={{ xs: 12, md: 12 }} className="user_pop_button" >
                    <DialogActions>
                        <Button variant="outlined" color="primary" className="btn3  cp" onClick={closeEditModal}>
                            Cancel
                        </Button>

                        <button variant="outlined" className="btn3 btn_primary cp" disabled={atvBtn} onClick={(e) => updateSkill()}>
                            <div className="btn_loader">
                                Save
                                &nbsp;
                                {atvBtn &&
                                    <div>
                                        <CircularProgress size={13} />
                                    </div>
                                }
                            </div>
                        </button>
                    </DialogActions>
                </Grid>
            </Dialog>

            {/* to link subskill in skillsubskill */}
            <Dialog
                onClose={closeLinkSubSkillModal}
                aria-labelledby="customized-dialog-title"
                open={isLinkSubSkillModalOpen}
                PaperProps={{
                    style: {
                        width: '600px',
                    },
                }}
            >
                <DialogTitle id="customized-dialog-title"
                    onClose={closeLinkSubSkillModal}
                    className="admindailog_title_modal"
                >
                    Link Sub-Skill
                    <IconButton
                        aria-label="close"
                        style={closeButton}
                        onClick={closeLinkSubSkillModal}>
                        <CloseIcon />
                    </IconButton>

                </DialogTitle>
                <DialogContent className="userlist_dailog_content">
                    <Grid size={{ xs: 12, md: 12 }}>
                        <Typography gutterBottom>
                            Sub-Skill
                        </Typography>
                        <Autocomplete
                            autoSelect
                            id="combo-box-demo"
                            options={allSubSkill}
                            getOptionLabel={(option) => option.name}
                            filterOptions={filterOptions}
                            renderInput={(params) => <TextField {...params} variant="outlined" placeholder="Select Sub-Skill" />}


                            onChange={
                                (e, value) => subSkillChangeHandlerForLink(e, value)
                            }
                        />
                    </Grid>
                    &nbsp;
                    <Grid size={{ xs: 12, md: 12 }}>
                        <Typography gutterBottom>
                            Skill
                        </Typography>
                        <Autocomplete
                            autoSelect
                            id="combo-box-demo"
                            options={allActivePrimarySkill}
                            getOptionLabel={(option) => option.name}
                            filterOptions={filterOptions}
                            renderInput={(params) => <TextField {...params} variant="outlined" placeholder="Select Skill" />}


                            onChange={
                                (e, value) => SkillChangeHandlerForLink(e, value)
                            }
                        />
                    </Grid>

                </DialogContent>
                <Grid size={{ xs: 12, md: 12 }} className="user_pop_button" >
                    <DialogActions>
                        <Button variant="outlined" color="primary" onClick={closeLinkSubSkillModal}>
                            Cancel
                        </Button>
                        <Button variant="outlined" style={btnSavegreen} color="primary" onClick={(e) => LinkSubSkill()}>
                            Save
                        </Button>
                    </DialogActions>
                </Grid>
            </Dialog>

        </>
    )
}

export default SubSkill;

